// File: src/components/SessionPanel/csv.ts
import type { UpdateEvent as NetUpdateEvent } from "../../types/domain";

export function exportCsv(sessionId: string | undefined, bubbles: NetUpdateEvent[]) {
  const header = ["seq", "ts", "start_sec", "end_sec", "speaker", "text"];
  const lines = [header.join(",")];
  for (const b of bubbles) {
    const row = [
      b.seq,
      (b as any).ts ?? "",
      b.start_sec ?? "",
      b.end_sec ?? "",
      (b.speaker || "").replace(/"/g, '""'),
      ((b.text ?? "") as string).replace(/\r?\n/g, " ").replace(/"/g, '""'),
    ];
    lines.push(row.map((v) => (typeof v === "string" ? `"${v}"` : String(v))).join(","));
  }
  const name = `session_${sessionId ?? "export"}.csv`;
  const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
